/**
 * 动态表单弹窗 — 校验规则转换
 */

import type { DynamicFormField } from './types';

/** 默认必填消息模板 */
const DEFAULT_REQUIRED_MESSAGE = '请输入{label}';

/**
 * 将 DynamicFieldRule 转换为 antd Form.Item 的 rules
 *
 * @param field - 表单字段配置
 * @param requiredMessage - 自定义必填消息模板，使用 `{label}` 占位符
 */
export function toAntdRules(field: DynamicFormField, requiredMessage?: string) {
  if (!field.rules?.length) return undefined;

  const msgTemplate = requiredMessage ?? DEFAULT_REQUIRED_MESSAGE;

  return field.rules.map((rule) => {
    // 自定义 validator 需要适配 antd 的异步校验签名
    if (rule.validator) {
      const userValidator = rule.validator;
      return {
        validator(_: unknown, value: unknown) {
          const errMsg = userValidator(value);
          return errMsg ? Promise.reject(new Error(errMsg)) : Promise.resolve();
        },
      };
    }

    const antdRule: Record<string, unknown> = {};
    if (rule.required) antdRule.required = true;
    if (rule.message) antdRule.message = rule.message;
    if (rule.min !== undefined) antdRule.min = rule.min;
    if (rule.max !== undefined) antdRule.max = rule.max;
    if (rule.pattern) antdRule.pattern = rule.pattern;

    // 为 required 规则提供默认消息
    if (rule.required && !rule.message) {
      antdRule.message = msgTemplate.replace('{label}', field.label);
    }

    return antdRule;
  });
}
